import React from "react";
import { Card, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Header from "./header";
import Footer from "./footer";
import { useNavigate } from "react-router-dom";
export default function PhpJobs() {
  const navigate = useNavigate();

  const handleApplyNow = (job) => {
    navigate(`/job-details/${job.id}`, { state: { job } });
  };
  // Sample job openings data for PHP roles
  const jobOpenings = [
    {
      title: "PHP Developer",
      company: "Techlight",
      location: "India, Remote",
      salary: "₹12L - ₹25L",
      description:
        "Techlight is seeking a PHP Developer to work on cutting-edge web applications using PHP. Collaborate with a highly skilled team to build scalable applications and solve complex technical challenges.",
    },
    {
      title: "Senior PHP Engineer",
      company: "InnoTechies",
      location: "India, Remote",
      salary: "₹15L - ₹30L",
      description:
        "Join InnoTechies as a Senior PHP Engineer, leading development efforts for high-performance web platforms. You’ll work closely with cross-functional teams to deliver clean, efficient code using PHP.",
    },
    {
      title: "PHP Backend Developer",
      company: "BackendMasters",
      location: "India, Remote",
      salary: "₹10L - ₹22L",
      description:
        "BackendMasters is looking for a PHP Developer to design and maintain the server-side logic for our applications. If you are proficient with PHP and Laravel, apply to work on backend systems that scale.",
    },
    {
      title: "PHP Frontend Developer",
      company: "ReactPros",
      location: "India, Remote",
      salary: "₹12L - ₹25L",
      description:
        "ReactPros is looking for a Frontend Developer with expertise in PHP. Join our team to build beautiful and responsive user interfaces for various web applications.",
    },
    {
      title: "Full Stack PHP Developer",
      company: "CodeCrafters",
      location: "India, Remote",
      salary: "₹14L - ₹28L",
      description:
        "CodeCrafters is hiring a Full Stack Developer proficient in PHP. You will be involved in both frontend and backend development, creating seamless and efficient web applications.",
    },
    {
      title: "PHP Architect",
      company: "VisionaryCoders",
      location: "India, Remote",
      salary: "₹18L - ₹35L",
      description:
        "VisionaryCoders is seeking a PHP Architect to design and lead the development of complex web applications. This is a leadership role focused on ensuring scalability, performance, and maintainability.",
    },
    {
      title: "PHP DevOps Engineer",
      company: "DevOpsMasters",
      location: "India, Remote",
      salary: "₹12L - ₹24L",
      description:
        "DevOpsMasters is looking for a PHP DevOps Engineer to handle the deployment, scaling, and maintenance of PHP applications. You will ensure smooth CI/CD processes and infrastructure scalability.",
    },

    {
      title: "Junior PHP Developer",
      company: "WebStartups",
      location: "India, Remote",
      salary: "₹8L - ₹15L",
      description:
        "WebStartups is looking for a Junior PHP Developer to join our growing team. You will work on various web projects, learning and growing your skills in PHP development.",
    },
    {
      title: "PHP Software Engineer",
      company: "SoftSolutions",
      location: "India, Remote",
      salary: "₹13L - ₹26L",
      description:
        "SoftSolutions is hiring a PHP Software Engineer to develop and maintain web applications. You will work with a team of talented developers to create high-quality software solutions.",
    },
    {
      title: "Lead PHP Developer",
      company: "InnovativeTech",
      location: "India, Remote",
      salary: "₹20L - ₹40L",
      description:
        "InnovativeTech is seeking a Lead PHP Developer to oversee our development team. You will be responsible for guiding the team, ensuring best practices, and delivering top-notch web applications.",
    },

    {
      title: "PHP Security Specialist",
      company: "SecureCode",
      location: "India, Remote",
      salary: "₹16L - ₹32L",
      description:
        "SecureCode is looking for a PHP Security Specialist to ensure the security of our web applications. You will be responsible for identifying vulnerabilities and implementing security measures.",
    },
    {
      title: "PHP Performance Engineer",
      company: "SpeedyWeb",
      location: "India, Remote",
      salary: "₹14L - ₹28L",
      description:
        "SpeedyWeb is hiring a PHP Performance Engineer to optimize the performance of our web applications. You will work on improving load times and ensuring smooth user experiences.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>PHP Developer Jobs 2025</title>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="description"
          content="Find remote PHP developer job opportunities with leading companies in 2025."
        />
        <meta
          name="keywords"
          content="PHP developer, remote jobs, PHP, Laravel"
        />
        <meta name="author" content="Your Name" />
      </Helmet>
      <Header />
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 mb-12 text-center">
            <h1 className="font-weight-bold">PHP Developer Jobs 2025</h1>
            <p className="lead">
              Explore exciting remote opportunities in PHP development with
              leading companies.
            </p>
          </div>
          {jobOpenings.map((job, index) => (
            <div key={job.id} className="col-md-12 mb-12">
              <Card>
                <Card.Body>
                  <Card.Title>{job.title}</Card.Title>
                  <Card.Text>{job.salary}</Card.Text>
                  <Card.Subtitle className="mb-12 text-muted">
                    {job.company} - {job.location}
                  </Card.Subtitle>
                  <Card.Text>{job.description}</Card.Text>
                  <div className="d-flex justify-content-between align-items-center">
                    <Button
                      variant="primary"
                      onClick={() => handleApplyNow(job)}
                    >
                      Apply Now
                    </Button>
                    <span>Today</span>
                  </div>
                </Card.Body>
              </Card>
              <br />
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
